import { App } from 'antd';

import { useIntl, useModel, useRequest } from '@umijs/max';

import { findDateRangeLabels, findFeatureNames, findSelectedFeatures, getFeatures } from './index';
import { FindDateRangeLabelsRequest } from './types';

export const useGetFeatures = () => {
  const intl = useIntl();
  const { message } = App.useApp();

  return useRequest(getFeatures, {
    cacheKey: 'getFeatures',
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    staleTime: Infinity,
  });
};

export const useFindFeatureNames = () => {
  const intl = useIntl();
  const { message } = App.useApp();

  return useRequest(findFeatureNames, {
    cacheKey: 'findFeatureNames',
    formatResult: (result: { value: string }[]) => result.map(({ value }) => ({ label: value, value })),
    manual: true,
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
  });
};

export const useFindSelectedFeatures = () => {
  const intl = useIntl();
  const { message } = App.useApp();

  return useRequest(findSelectedFeatures, {
    cacheKey: 'findSelectedFeatures',
    formatResult: (result: { value: string }[]) => result.map(({ value }) => ({ label: value, value })),
    manual: true,
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
  });
};

export const useFindDateRangeLabels = (deviceId?: string) => useRequest(findDateRangeLabels, {
  cacheKey: 'findDateRangeLabels',
  manual: true,
  ready: !!deviceId,
});

export const useFindDateRangeLabelsForRange = (payload: FindDateRangeLabelsRequest | null) => {
  const intl = useIntl();
  const { message } = App.useApp();
  const { searchVersion } = useModel('showSamplesDetails');

  return useRequest(() => findDateRangeLabels(payload!), {
    cacheKey: 'findDateRangeLabels:range',
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    ready: !!payload?.dateFrom && !!payload.dateTo && !!payload.deviceId,
    refreshDeps: [payload?.dateFrom, payload?.dateTo, payload?.deviceId, searchVersion],
  });
};
